import { api } from '@packages/backend/convex/_generated/api';
import type { MenuCvx } from '@packages/shared';
import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from 'convex-helpers/react';
import { useState } from 'react';
import { LoadingIcon } from '@/components/ui+/LoadingIcon';
import { CategoriesRearrangeList } from './categories/components/CategoriesRearrangeList';
import { CategoriesTable } from './categories/components/CategoriesTable';

export const Route = createFileRoute('/r/$restaurantId/menu/categories')({
  component: Component,
});

function Component() {
  const { restaurantId } = Route.useParams();
  const { data, isError, isPending } = useQuery(api.menus.getByRestaurantId, { restaurantId });
  const [isRearranging, setIsRearranging] = useState(false);

  if (isPending) {
    return <LoadingIcon />;
  }
  if (isError) return null; // Handled by parent component
  const menu: MenuCvx | null = data;
  if (menu === null) {
    return null; // Handled by menu items tab
  }

  return (
    <div className={'xl:w-2/3'}>
      {isRearranging ? (
        <CategoriesRearrangeList
          categories={menu.categories}
          menuId={menu._id}
          onRearrangingDone={() => setIsRearranging(false)}
        />
      ) : (
        <CategoriesTable
          categories={menu.categories}
          menuId={menu._id}
          menuItems={menu.menuItems}
          onRearrange={() => setIsRearranging(true)}
        />
      )}
    </div>
  );
}
